'use client';

import Image from 'next/image'
import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import Button from '@/components/Button';
import { Splide, SplideSlide } from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import { getStrapiImageUrl, getStrapiImageWidth, getStrapiImageHeight } from '@/app/lib/util';
import {HeroProps} from "@/app/types/flexible-content.types";
interface CallToActionItemProps {
	title: string
	content: string
}

function CallToActionItem(props: CallToActionItemProps) {
	return (
		<div className="flex items-center">
			<div className="text-4xl font-bold mr-6 whitespace-nowrap">{props.title}</div>
			<div className="opacity-60 flex-wrap">{props.content}</div>
		</div>
	)
}


export default function Hero(props: {data: HeroProps}) {
    return (
        <>
            <section className="py-16 lg:py-28 relative">
				<div className="w-full absolute top-0 left-0 bottom-0 right-0 overflow-hidden">
					<div className="w-full h-full absolute top-0 left-0 bottom-0 right-0 bg-gradient-to-r from-black/30 to-black/0"></div>
					<Image className="w-full h-full object-cover" priority quality={85} src={getStrapiImageUrl(props.data.HeroImage)} width={getStrapiImageWidth(props.data.HeroImage)} height={getStrapiImageHeight(props.data.HeroImage)} alt="Get started with as little as 3 coins" />
				</div>
				<div className="container flex flex-col lg:flex-row items-center justify-between relative z-10">
					<div className="w-full lg:w-1/2">
						<h1 className="text-5xl xl:text-6xl text-white font-bold mb-8">
							<ReactMarkdown
								// @ts-expect-error
								rehypePlugins={[rehypeRaw]}
								className="titlespan"
							>
								{props.data.Title}
							</ReactMarkdown>
						</h1>
						{props.data.Reason.length > 0 ? (
							<div className="grid grid-cols-1 gap-gap-3 mb-12 text-xl font-medium">
								{props.data.Reason.map((item, index: number) => (
									<div className="flex items-start justify-start text-sm lg:text-base text-white" key={index}><FontAwesomeIcon icon={faCheck} className="mr-3 text-[#43C265]" />{item.Value}</div>
								))}
							</div>
						) : null}
						{props.data.Content ? (
							<div className="text-white text-xl mb-12">
								<ReactMarkdown
									// @ts-expect-error
									rehypePlugins={[rehypeRaw]}
									className="titlespan"
								>
									{props.data.Content}
								</ReactMarkdown>
							</div>
						) : null}
						{props.data.ButtonGroup ? (
							<>
								{props.data.ButtonGroup.map((button, index: number) => (
									<Button key={index}link={button.ButtonLink} class="px-12 justify-center text-xl inline-flex text-white" label={button.ButtonLabel} />
								))}
							</>
						) : null}

					</div>
				</div>
			</section>
			{props.data.Stat ? (
				<section className="py-4 xl:py-12">
					<div className="container">
						<Splide
							options={{
								arrows: false,
								pagination: false,
								perPage: 1,
								gap: 40,
								autoplay: true,
								interval: 2000,
								drag: true,
								mediaQuery: "min",
								breakpoints: {
									1024: {
										perPage: 2,
									},
									1280: {
										perPage: 3,
										autoplay: false,
										drag: false,
									}
								}
							}}
						>
							{props.data.Stat.map((item: { StatValue: string, StatLabel: string }, index: number) => (
								<SplideSlide key={index}>
									<CallToActionItem title={item.StatValue} content={item.StatLabel} />
								</SplideSlide>
							))}

						</Splide>
					</div>
				</section>
			) : null}
        </>
    )
}